require('../../modules/es6.object.set-prototype-of');
module.exports = require('../../modules/_core').Object.setPrototypeOf;



//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/~/core-js/library/fn/object/set-prototype-of.js
// module id = 1457
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16